import React from "react";
import { Button } from "carbon-components-react";
import { RuleCancelled24, Undo24 } from "@carbon/icons-react";
import { useNavigate } from "react-router-dom";

const CancelButton = ({ label, navigateTo, icon, kind }) => {
  const navigate = useNavigate();
  const handleCancel = () => {
    navigate(navigateTo && navigateTo.trim() ? navigateTo : -1);
  };
  return (
    <Button
      renderIcon={icon}
      iconDescription={label}
      kind={kind}
      onClick={handleCancel}
    >
      {label}
    </Button>
  );
};

CancelButton.defaultProps = {
  label: "Cancelar",
  icon: RuleCancelled24,
  kind: "secondary",
};

export default CancelButton;
